

























import { Component, Vue } from 'vue-property-decorator';
import PopupCloseButton from '@/components/popups/PopupCloseButton.vue';
import Popup from '@/components/popups/Popup.vue';
import { namespace } from 'vuex-class';

const ui = namespace('UI');

@Component({
  components: {
    Popup,
    PopupCloseButton,
  },
})
export default class HelpPopup extends Vue {
  @ui.Mutation
  private closePopup!: () => void;

  get helpStyle() {
    if ((window as any).locale === 'de') {
      return `
      width: 26em;
      height: 420px;
    `;
    }

    return `
      width: 26em;
      height: 380px;
    `;
  }

  private help1: string = (window as any).languages['Help1'];
  private help2: string = (window as any).languages['Help2'];
  private help3: string = (window as any).languages['Help3'];
  private help4: string = (window as any).languages['Help4'];
}
